import React from "react";
import { FiCopy } from "react-icons/fi";
import { toast } from "react-toastify";

const WebhookUrlPanel = ({ label, url, hint, copyLabel, copiedLabel, copyFailedLabel }) => {
  const handleCopy = async () => {
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
      toast.success(copiedLabel);
    } catch {
      toast.error(copyFailedLabel || copyLabel);
    }
  };

  if (!url) return null;

  return (
    <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-4 text-sm text-emerald-900">
      <p className="font-medium">{label}</p>
      <div className="mt-2 flex flex-wrap items-start gap-2">
        <code className="min-w-0 flex-1 break-all rounded-lg bg-white/70 px-2 py-1.5 text-xs ring-1 ring-emerald-100">
          {url}
        </code>
        <button
          type="button"
          onClick={handleCopy}
          className="inline-flex h-9 shrink-0 items-center gap-1.5 rounded-lg border border-emerald-200 bg-white px-3 text-xs font-semibold text-emerald-800 transition hover:bg-emerald-100"
        >
          <FiCopy className="h-3.5 w-3.5" />
          {copyLabel}
        </button>
      </div>
      {hint ? <p className="mt-2 text-xs leading-5 text-emerald-800">{hint}</p> : null}
    </div>
  );
};

export default WebhookUrlPanel;
